import React, {Component} from 'react'
import FilterFooterComponent from './FilterFooter.component'

class FilterFooterContainer extends Component {
  handleApplyClick = (evt) => {
    // logic to apply filters here
    evt.preventDefault()
    this.props.handleClickApplyFilters()
    this.props.handleFilterOpen()
  }

  handleClearClick = (evt) => {
    // logic to clear filters here
    evt.preventDefault()

    this.props.handleClearFilters()
  }

  handleCheckChange = (checkStatus) => {
    this.props.handleSaveFiltersCheck(!checkStatus)
  }

  render () {
    const events = {
      handleApplyClick: this.handleApplyClick,
      handleClearClick: this.handleClearClick,
      handleCheckChange: this.handleCheckChange
    }

    const checked = this.props.saveFiltersChecked

    const { savedFilters, validationErrors, i18n } = this.props

    return (
      <FilterFooterComponent validationErrors={validationErrors} events={events} checked={checked} i18n={i18n} savedFilters={savedFilters} />
    )
  };
}

export default FilterFooterContainer
